export const coopSettings = {
   baseURL : 'https://api.coopsys.com.do/facturing/1.0',
 // baseURL : 'http://localhost:3902',
 };
